module.exports = __webpack_public_path__ + "images/file_icons_v2/tar-5a5333ca1cc2d55d8eae1cec63972886.svg";